const fetcherOptions = {
  method: "GET",
  // Default HTTP method
  headers: {
    "Content-Type": "application/json"
    // Default content type
  },
  credentials: "include"
};
const removeUndefined = (obj) => {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === void 0) {
      delete obj[key];
    }
  });
  return obj;
};
const deepMerge = (objects) => objects.reduce((acc, obj) => {
  const acc1 = acc ?? {};
  const obj1 = removeUndefined(obj ?? {});
  if (typeof acc1 === "object" && typeof obj1 === "object") {
    return { ...acc1, ...obj1 };
  }
  return obj1 ?? acc1;
}, {});
const fetcher = async (url, ...options) => {
  const { signal } = new AbortController();
  let paramsString = "";
  let bodyString = void 0;
  const otherOptions = options.map(
    ({ body, params: params2, headers, ...otherOptions2 }) => otherOptions2
  );
  const mergedOptions = deepMerge([fetcherOptions, ...otherOptions]);
  const mergedHeaders = deepMerge([
    fetcherOptions.headers,
    ...options.map((option) => option.headers)
  ]);
  const params = deepMerge(options.map((option) => option.params));
  const method = mergedOptions.method;
  if (method !== "GET" && method !== "HEAD") {
    const body = deepMerge(options.map((option) => option.body));
    if (mergedHeaders?.["Content-Type"] === "application/x-www-form-urlencoded") {
      bodyString = new URLSearchParams(
        body
      ).toString();
    } else {
      bodyString = JSON.stringify(body);
    }
  }
  if (Object.entries(params).length > 0) {
    paramsString = `?${new URLSearchParams(
      params
    ).toString()}`;
  }
  const formattedOptions = {
    ...mergedOptions,
    headers: mergedHeaders,
    body: bodyString,
    signal
  };
  const urlResult = `${url}${paramsString}`;
  const response = await fetch(urlResult, formattedOptions);
  if (!response.ok) {
    const result = await response.json();
    throw new Error(JSON.stringify(result.error) ?? "An error occurred");
  }
  return await response.json();
};
export {
  fetcher,
  fetcherOptions
};
//# sourceMappingURL=fetcher.mjs.map